import React, { FC } from "react";
import { SearchResultItemViewModel } from "./SearchResultItemViewModel.csharp";

export const SearchResultItem: FC<SearchResultItemViewModel> = ({
  title,
  intro,
  highlightsHtml,
  link,
}) => {
  return (
    <div className="card card-hover">
      <div className="card-body">
        <h3 className="h5 card-title search-result-item-title">
          <a className="card-block-link" href={link}>
            {title}
          </a>
        </h3>
        {intro && <p dangerouslySetInnerHTML={{ __html: intro }} />}
        {highlightsHtml && (
          <p dangerouslySetInnerHTML={{ __html: highlightsHtml }} />
        )}
      </div>
    </div>
  );
};
